import { supabase } from './supabase'
import type { Bounce } from './types'

/**
 * The reads/writes side of bounces — shared between the "Mark as bounced"
 * quick action and the general report form on `AgentPanel.tsx`, and the
 * cross-agent Bounces tab (`routes/Bounces.tsx`). Untestable under the
 * plain-Node harness the same way `tasks.ts`/`outbox.ts`/`sender.ts` are —
 * this file imports `supabase`. `resend-webhook.ts` writes `source:
 * 'resend'` rows itself, directly via the service role — this file only
 * ever produces `source: 'manual'` ones.
 */

export async function reportBounce(
  agentId: string,
  address: string,
  opts: {
    subject?: string | null
    kind?: 'bounced' | 'complained'
    reason?: string | null
    draftId?: number | null
    reportedBy: string | null
  },
): Promise<{ bounce: Bounce | null; error: string | null }> {
  const trimmedAddress = address.trim()
  if (!trimmedAddress) return { bounce: null, error: 'An address is needed to record a bounce.' }
  const { data, error } = await supabase
    .from('bounces')
    .insert({
      agent_id: agentId,
      address: trimmedAddress,
      subject: opts.subject?.trim() || null,
      kind: opts.kind ?? 'bounced',
      source: 'manual',
      draft_id: opts.draftId ?? null,
      reason: opts.reason?.trim() || null,
      reported_by: opts.reportedBy,
    })
    .select('*')
    .single()
  if (error) return { bounce: null, error: error.message }
  return { bounce: data as Bounce, error: null }
}

export async function deleteBounce(id: number): Promise<string | null> {
  const { error } = await supabase.from('bounces').delete().eq('id', id)
  return error?.message ?? null
}
